import React, { useState } from 'react'
import Page from '../../pages/components/Page'
import Breadcrumbs from '../../components/Breadcrumbs'
import ItemsRequestsApp from './ItemsRequestsApp'
import BetaLabel from '../admin/components/BetaLabel'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { ItemsRequestModel } from '.'
import { ISearchParam } from '../BaseApp'
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer'
import GridData from '../../components/GridData/GridData'
import Grid from '@mui/material/Grid2';
import { Button } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import { ICellRendererParams } from 'ag-grid-community'
import { Link } from 'react-router-dom'

export default function MyRequests() {

    const itemsRequestApp = new ItemsRequestsApp()

    const [requests, setRequests] = useState<ItemsRequestModel[]>([])
    const [search, setSearch] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(true)
    const [selectedItems, setSelectedItems] = useState<ItemsRequestModel[]>([])
    const [searchParams, setSearchParams] = useState<ISearchParam[]>([])
    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })

    return(
        <Page>
            <div className="view-single-request-page-container content-section-wrapper page-container-wrapper">

                <div className="admin-base-page-head-section-container" style={{ marginBottom: 35 }}>
                    <div className="content-of-admin-base-page-head-section-container">

                        <Grid container>

                            <Grid size={{ xs: 10 }}>
                                <div className="text-box-of-admin-base-page-head-section-container">
                                    <div className="content-of-text-box-of-admin-base-page-head-section-container">

                                        <h2>
                                            My Requests
                                            {itemsRequestApp.isBeta && <BetaLabel />}
                                        </h2>
                                            
                                        <Breadcrumbs breadcrumbs={[
                                            {
                                                title: "Home",
                                                link: "/"
                                            },
                                            {
                                                title: "My Requests",
                                            },
                                        ]} />

                                    </div>
                                </div>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                <div className="action-box-of-admin-base-page-head-section-container">
                                    <div className="content-of-action-box-of-admin-base-page-head-section-container">

                                        <Button startIcon={<GenerateIcon icon="new" />} variant="contained" className="general-button admin-style" href="/requests/new">New Request</Button>

                                    </div>
                                </div>
                            </Grid>

                        </Grid>

                    </div>
                </div>

                <SectionBoxContainer>
                    <GridData 
                        items={requests}
                        columns={[
                            {
                                field: "request_number",
                                headerName: "Request No.",
                                width: 250,
                                type: "text",
                                cellRenderer: (params: ICellRendererParams<ItemsRequestModel>) => {
                                    const item = params.data

                                    if (!item){
                                        return params.value
                                    }

                                    return(
                                        <div className="grid-data-current-item-location-box">
                                            <Link className="data-grid-link" to={`/requests/${item.request_number}`}>
                                                <h3 className="title">{item.request_number}</h3>
                                            </Link>
                                        </div>
                                    )
                                }
                            },
                            ...itemsRequestApp.gridDataColumns.slice(1), 
                        ]}
                        selectedItems={selectedItems}
                        pagination={pagination}
                        search={search}
                        searchParams={searchParams}
                        loading={loading}
                        actionButtons={[]}
                        headerOptions={[]}
                        handleLoadItems={itemsRequestApp.myRequestsList}
                        updateSearch={(search) => setSearch(search)}
                        setSelectedItems={(items) => setSelectedItems(items)}
                        onDeleteItem={itemsRequestApp.deleteInstance}
                        onDeleteManyItems={itemsRequestApp.deleteManyInstances}
                        deleteItem={(id, dispatch) => {}}
                        updateLoading={(loading) => setLoading(loading)}
                        updateItemSearchParams={(params) => setSearchParams(params)}
                        addNewItem={(item, dispatch) => {}}
                        updateItem={(i, d) => {}}
                        updateAllItems={(i, d) => setRequests(i)}
                        updateItemsPagination={(pagination) => setPagination(pagination)}
                        config={{
                            viewItemLink: "",
                            editItemLink: "",
                            disableDelete: true,
                            disableSelect: true,
                            disableActionButtons: true,
                        }}
                    />
                </SectionBoxContainer>

            </div>
        </Page>
    )
}